import React, { Fragment, useEffect, useRef } from "react";
import makeStyles from "@mui/styles/makeStyles";
import {
  Button,
  Paper,
  MenuList,
  Popper,
  Grow,
  ClickAwayListener,
  Avatar,
} from "@mui/material";
import { useSelector } from "react-redux";
import { isBlank } from "../util/ext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  button: {
    width: "auto",
    height: "50px",
    borderRadius: "50px",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },

  username: {
    color: theme.palette.primary.darker,
  },

  org: {
    color: theme.palette.primary.dark,
  },

  menuContainer: {
    zIndex: "1000",
  },

  menu: {
    borderRadius: "5px",
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    width: "170px",
  },

  avatar: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },

  userInfo: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    paddingLeft: theme.spacing(2),
  },
}));

const UserProfileDropDown = props => {
  const classes = useStyles();
  const { menu, setOpenMenu, openMenu } = props;

  const { currentOrganization, user } = useSelector(state => state.auth);

  const anchorRef = useRef(null);
  const toggleMenu = () => setOpenMenu(!openMenu);
  const closeMenu = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenMenu(false);
  };

  const handleListKeyDown = event => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenMenu(false);
    }
  };

  const prevOpen = useRef(openMenu);
  useEffect(() => {
    if (prevOpen.current === true && openMenu === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = openMenu;
  }, [openMenu]);

  return (
    <Fragment>
      <Button
        ref={anchorRef}
        onClick={toggleMenu}
        classes={{ root: classes.button, label: classes.label }}
        endIcon={<ExpandMoreIcon style={{ color: "black" }} />}
        aria-controls={openMenu ? "user-profile-drop-down" : undefined}
        aria-haspopup="true"
        disableRipple
      >
        <Avatar className={classes.avatar}>
          <PersonIcon fontSize="large" />
        </Avatar>
        <div className={classes.userInfo}>
          <Typography className={classes.username}>{user.username}</Typography>
          <Typography className={classes.org}>
            {isBlank(currentOrganization) ? "Admin" : currentOrganization.name}
          </Typography>
        </div>
      </Button>
      <Popper
        className={classes.menuContainer}
        open={openMenu}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement={"bottom-end"}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper classes={{ root: classes.menu }}>
              <ClickAwayListener onClickAway={closeMenu}>
                <MenuList
                  autoFocusItem={openMenu}
                  id="user-profile-drop-down"
                  onKeyDown={handleListKeyDown}
                >
                  {menu}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>
  );
};

export default UserProfileDropDown;
